// WorkflowTree.jsx - Modified to have tree collapsed by default
import React, { useState, useEffect, useRef } from 'react';
import { Tree, Menu, Input, Button, message, Modal, Divider } from 'antd';
import { FolderOpenOutlined, BranchesOutlined, PlusOutlined } from "@ant-design/icons";
import '../assets/styles/common.css';
import { getWorkflowList, manageWorkflowCategory, saveWorkflow } from '../../../services/admin/adminService';
import CustomTree from '../components/CommonFields/Tree';

const WorkflowTree = ({ onTreeSelect }) => {
    const [isCategoryModalVisible, setIsCategoryModalVisible] = useState(false);
    const [categoryName, setCategoryName] = useState('');
    const [selectedCatId, setSelectedCatId] = useState(null);
    const [childToParentMap, setChildToParentMap] = useState({});
    const [treeData, setTreeData] = useState([]);
    const [contextMenu, setContextMenu] = useState(null);
    const [popoverVisible, setPopoverVisible] = useState(false);
    const [workflowInput, setWorkflowInput] = useState('');
    const [expandedKeys, setExpandedKeys] = useState([]);

    //#region useEffect
    const fetchWorkflows = async () => {
        try {
            const res = await getWorkflowList();
            if (res.success) {
                if (res.workflow != null && res.workflow != undefined && res.workflow.length > 0) {
                    const workflowData = res.workflow[0];
                    const treeJson = JSON.parse(workflowData[0].tree_json);
                    const updatedTreeData = treeJson.map((category) => ({
                        title: (
                            <div className="manager-node">
                                {category.title}
                            </div>
                        ),
                        key: category.key,
                        icon: <FolderOpenOutlined />,
                        children: category.children?.map((workflow) => ({
                            title: (
                                <div className="step-node">
                                    <div className="step-content-inline">
                                        <span className="step-name">{workflow.title}</span>
                                    </div>
                                </div>
                            ),
                            key: workflow.key,
                            icon: <BranchesOutlined />,
                        })) || [],
                    }));

                    setTreeData(updatedTreeData);
                    // No longer automatically expanding all keys
                }
            }
        } catch (error) {
            console.error("Error fetching workflows:", error);
        }
    };

    useEffect(() => {
        fetchWorkflows();
    }, []);

    useEffect(() => {
        const map = buildParentMap(treeData);
        setChildToParentMap(map);
    }, [treeData]);
    //#endregion

    // Helper function outside the component
    const buildParentMap = (nodes, parent = null, map = {}) => {
        nodes.forEach(node => {
            map[node.key] = parent;
            if (node.children) {
                buildParentMap(node.children, node.key, map);
            }
        });
        return map;
    };

    const handleRightClick = ({ event, node }) => {
        event.preventDefault();

        if (node.children !== undefined) {
            setContextMenu({
                pageX: event.clientX,
                pageY: event.clientY,
                node,
            });
            setSelectedCatId(node.key);
            setPopoverVisible(true);
        }
    };

    const handleTreeNodeClick = (selectedKeys, info) => {
        const node = info.node;
        if (!node.children || node.children.length === 0) {
            const selectedNodeKey = selectedKeys[0];
            const parentKey = childToParentMap[selectedNodeKey];
            setSelectedCatId(parentKey);
            onTreeSelect({
                wfName: node.title,
                wfId: node.key,
                wfCategoryId: parentKey,
            });
        }
    }

    const handleCategorySave = async () => {
        if (!categoryName.trim()) {
            message.error('Category name cannot be empty');
            return;
        }
        try {
            const action = 'update';
            if (categoryName !== null && categoryName !== "") {
                const res = await manageWorkflowCategory(0, categoryName, action);
                if (res.data.success) {
                    fetchWorkflows();
                    message.success(`Category updated successfully`);
                    setCategoryName('');
                    setIsCategoryModalVisible(false);
                }
                else if (res.data.businessRules) {
                    message.error(res.data.businessRules[0]);
                }
            }
            else {
                message.error('Category name cannot be empty');
            }
        } catch (error) {
            console.error("Error managing workflow category:", error);
            message.error("Failed to manage workflow category");
        }
    };

    const handleSaveWorkflow = async () => {
        if (!workflowInput.trim()) {
            message.error('Workflow name cannot be empty');
            return;
        }
        if (workflowInput !== null && workflowInput !== "" && selectedCatId !== null && selectedCatId !== "") {
            const res = await saveWorkflow(workflowInput, selectedCatId);
            if (res.data.success) {
                const msg = ": " + res.data?.businessRules?.[0] || "";
                fetchWorkflows();
                message.success(`Workflow updated successfully: ${msg}`);
                setWorkflowInput('');
                setPopoverVisible(false);
            }
            else if (res.data.businessRules) {
                message.error(res.data.businessRules[0]);
            }
        }
        else {
            message.error('Workflow name cannot be empty');
        }
    };

    const showCategoryModal = () => {
        setIsCategoryModalVisible(true);
        setContextMenu(null);
    };

    return (
        <div style={{ position: 'relative', width: '100%' }}>
            <div style={{ display: 'flex', justifyContent: 'space-evenly', alignItems: 'center', marginBottom: 12 }}>
                <h3 style={{ margin: 0 }}>Workflow List</h3>
                <Button type="primary" icon={<PlusOutlined />} onClick={showCategoryModal}>
                    Add
                </Button>
            </div>
            <Divider style={{ margin: '10px 0px', padding: '0px' }}></Divider>
            {/* <Tree onRightClick={handleRightClick} defaultExpandAll
        //         showIcon={false} defaultExpandedKeys={0} onSelect={handleTreeNodeClick} treeData={treeData}
        //     /> */}
            {/* <CustomTree
                treeData={treeData}
                onSelect={handleTreeNodeClick}
                onRightClick={handleRightClick}
                expandedKeys={expandedKeys}
                onExpand={handleExpand}
                showLine={{ showLeafIcon: false }}
                showIcon={false}
                className="workflow-tree"
                defaultExpandAll={false}
                defaultExpandedKeys={0}
                autoExpandParent={false}
            /> */}

            <CustomTree
                onRightClick={handleRightClick}
                defaultExpandAll
                defaultExpandedKeys={0}
                onSelect={handleTreeNodeClick}
                treeData={treeData}
                className="workflow-tree"
            />


            {contextMenu && (
                <Modal
                    open={popoverVisible}
                    title={
                        <span>
                            Add new workflow for <span style={{ color: "Highlight" }}>{contextMenu.node.title}</span>
                        </span>
                    }
                    onCancel={() => setPopoverVisible(false)}
                    onOk={handleSaveWorkflow}
                    okText="Save"
                >
                    <div>
                        <Input
                            placeholder="Workflow name"
                            value={workflowInput}
                            onChange={(e) => setWorkflowInput(e.target.value)}
                        />
                    </div>
                </Modal>
            )}

            <Modal
                title="Add New Category"
                open={isCategoryModalVisible}
                onCancel={() => setIsCategoryModalVisible(false)}
                onOk={handleCategorySave}
                okText="Save"
            >
                <Input
                    placeholder="Enter category name"
                    value={categoryName}
                    onChange={(e) => setCategoryName(e.target.value)}
                />
            </Modal>
        </div>
    );
};

export default WorkflowTree;